export const JITSI_EVENTS = {
    CONFERENCE_FAILED: "conferenceFailed",
    CONNECTION_FAILED: "connectionFailed",
    MIC_ERROR: "micError",
    CAMERA_ERROR: "cameraError",
    ERROR_OCCURRED: "errorOccurred",
} as const;

export const TAKEOVER_DISPOSE_TIMEOUT = 2000;
